import { useCallback, useMemo } from "react";
import { isEmpty } from "lodash";

const LOAD_MORE_NODE_ID = "__load-more-objectives__";

const useDisplayTreeData = ({
  treeData,
  hasMore,
  loadingMore,
  handleLoadMore,
  totalFetchedCount,
  totalCount,
}) => {
  const displayTreeData = useMemo(() => {
    if (isEmpty(treeData)) {
      return treeData;
    }

    if (loadingMore) {
      return [
        ...treeData,
        {
          id: LOAD_MORE_NODE_ID,
          name: "Loading...",
          active: false,
          toggled: false,
          children: null,
          noActivation: true,
        },
      ];
    }

    if (hasMore) {
      return [
        ...treeData,
        {
          id: LOAD_MORE_NODE_ID,
          name: `Load more (${totalFetchedCount} of ${totalCount} loaded)`,
          active: false,
          toggled: false,
          isLoadMore: true,
          children: null,
        },
      ];
    }

    return treeData;
  }, [treeData, hasMore, loadingMore, totalFetchedCount, totalCount]);

  const onNodeSelected = useCallback(
    (node) => {
      if (node.isLoadMore) {
        handleLoadMore({
          includeChildObjectivesParam: false,
        });
      }
    },
    [handleLoadMore]
  );

  return { displayTreeData, onNodeSelected };
};

export default useDisplayTreeData;
